// types.ts
import { IconType } from 'react-icons';

export enum TokenType {
  Field = 'Field',
  ArithmeticOperator = 'ArithmeticOperator',
  Value = 'Value',
  LogicalOperator = 'LogicalOperator',
}

export interface Token {
  type: 'field' | 'operator' | 'value' | 'logical' | 'parenthesis';
  value: string;
  start: number;
  end: number;
  raw: string;
}

export interface Suggestion {
  type: 'field' | 'operator' | 'value' | 'logical';
  value: string;
  label: string;
  icon: IconType | null;
  description: string | null;
  isHint?: boolean; // New property to identify hints vs actual suggestions
  noQuotes?: boolean; // Flag to indicate this value should not be wrapped in quotes
}

export interface TokenizerResult {
  tokens: Token[];
  currentToken: Token | null;
  expectedNext: TokenType;
  cursorContext: {
    insideToken: boolean;
    tokenIndex: number;
    positionInToken: number;
  } | null;
}
